import { LogRegLogo } from "../util/LogRegLogo";
import Tos from "./Tos";
import React from "react";
import googleImg from './icons/google.png';
import mailImg from './icons/mail.png';
import GoogleAuthButton from "../login/GoogleAuthButton";
import { GoogleMember } from "../../generated/account-client";
import { Spinner } from "../account/misc/Spinner";

export interface RegOrLoginDecision {
  gMember?: GoogleMember;
  type: 'email' | 'google'
}

export interface RegStepZeroProps {
  onDecision: (decision: RegOrLoginDecision) => void;
  loading: boolean;
  onStartLoading: () => void;
}

export default function RegStepZero({ onDecision, loading, onStartLoading }: RegStepZeroProps) {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source') || '';

  function onEmailClick() {
    onDecision({ type: 'email' });
  }

  async function onGoogleRegister(gMember: GoogleMember) {
    onDecision({ type: 'google', gMember });
  }

  return (
    <div className={"step-type step full"}>
      <LogRegLogo />
      {source === 'popmenu'
        ? <h2>Create your account</h2>
        : <h2>Login or sign up in seconds</h2>
      }
      {source === 'popmenu'
        ? <h5>Please register to make your menu items available for use on MustHaveMenus.</h5>
        : <h5>Use your email or Google to continue with MustHaveMenus.</h5>
      }

      {loading && <Spinner />}
      {!loading && <div className="login-buttons">
        <div>
          <img src={googleImg} alt="Google" />
          <span className={'login-option'}>Continue with Google</span>
          <GoogleAuthButton hidden onSuccess={onGoogleRegister} onStartLoading={onStartLoading} />
        </div>
        <div onClick={onEmailClick}>
          <img src={mailImg} alt="Email" />
          <span className={'login-option'}>Continue with Email</span>
        </div>
      </div>}
      <Tos />
    </div>
  );
}
